export default "__VITE_ASSET__Cjql9GCM__"